<template>
  <div>

    <div v-if="!editMode && domainsWhitelist.length === 0" class="alert alert-danger" role="alert">
      <b>No domain is whitelisted.</b> You won't be able to connect to Amio Chat unless you whitelist your domain.
    </div>
    <channel-field v-if="!editMode" class="mb-3">
      <div slot="label">
        Domain Whitelist:
        <span id="amio_chat_info_domain_whitelist"
              v-b-popover:amio_chat_info_domain_whitelist.html.hover.right="whitelistInfoText">
          <icon name="info-circle"></icon>
        </span>
      </div>

      <div slot="value">
        <domain-whitelist-read-only
          :domains="domainsWhitelist"></domain-whitelist-read-only>
      </div>
    </channel-field>

    <div v-else class="row form-group">
      <label for="domain-whitelist" class="col-form-label col-4 col-xl-3 text-muted">
        Domain Whitelist:
        <span id="amio_chat_info_domain_whitelist_edit"
              v-b-popover:amio_chat_info_domain_whitelist_edit.html.hover.right="whitelistInfoText">
          <icon name="info-circle"></icon>
        </span>
      </label>
      <div class="col-8 col-xl-9">
        <domain-whitelist-editable id="domain-whitelist"
                                   @domains-updated="updateDomains"
                                   :errors="errorsDomainWhitelist"
                                   :domains="domainsWhitelist"></domain-whitelist-editable>
      </div>
    </div>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import clone from 'ramda/src/clone'
  import EditableDomainWhitelist
    from '@/components/administration/channel/common/domain_whitelist/DomainWhitelistEditable'
  import DomainWhitelist from '@/components/administration/channel/common/domain_whitelist/DomainWhitelistReadOnly'

  const whitelistInfoText = 'Only the whitelisted domains will be allowed for cross origin requests (CORS) during connection to Amio Chat servers.\n\nIf you want to whitelist localhost, please use format: <code>http://localhost:{port}</code>'

  export default {
    props: {
      editMode: {
        type: Boolean,
        required: true
      },
      settings: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      }
    },

    data() {
      return {
        whitelistInfoText
      }
    },

    components: {
      'channel-field': ChannelDetailField,
      'domain-whitelist-read-only': DomainWhitelist,
      'domain-whitelist-editable': EditableDomainWhitelist
    },

    store: {
      settingsEdit: 'administration.channelDetail.settingsEdit'
    },

    watch: {
      editMode: function () {
        if (this.editMode) {
          this.prepareStore()
        } else {
          this.cleanUpStore()
        }
      }
    },

    computed: {
      domainsWhitelist() {
        return this.settings.domains_whitelist || []
      },

      errorsDomainWhitelist() {
        // Returning {} prevents error in Vue, where it complains receiving FALSE instead of an object
        return this.errors.domains_whitelist || {}
      }
    },

    methods: {
      updateDomains(domains) {
        this.settingsEdit.domains_whitelist = domains
      },

      prepareStore() {
        // load data to store
        this.settingsEdit = clone(this.settings)
      },

      cleanUpStore() {
        this.settingsEdit = {}
      }
    },

    destroyed() {
      this.cleanUpStore()
    }
  }
</script>
